import { deviceManager } from '@hid/device/device_manager'
import { fakeSocket } from '@hid/fakesocket/fakesocket'
import { MusicCaptureStatus } from '@libs/types/enum'
import { DriverSocketMsg, DriverSocketMsgType } from '@libs/types/message'
import { PostDynamicColor, PostMusicData } from '@libs/types/response'
import { generateMessageID } from '@libs/utils/tools'
import { MusicSocket } from './music_socket'
import { isElectron } from '@libs/utils/envUtils'

export class musicData {
  private colorsDynamic: PostDynamicColor | null = null
  private musicDataHandlerFunc: ((data: number[]) => void) | null = null

  constructor(musicDataHandlerFunc: (data: number[]) => void) {
    this.musicDataHandlerFunc = musicDataHandlerFunc
  }

  setColorsDynamic(colorsDynamic: PostDynamicColor) {
    this.colorsDynamic = colorsDynamic
  }

  private musicCaptureStatus = MusicCaptureStatus.None

  getMusicCaptureStatus() {
    return this.musicCaptureStatus
  }

  async musicCapturePause() {
    await this.dynamicColorState(MusicCaptureStatus.Pause)
  }

  async musicCaptureContinue() {
    await this.dynamicColorState(MusicCaptureStatus.Continue)
  }

  async dynamicColorState(state: MusicCaptureStatus): Promise<boolean> {
    const colorsDynamic = this.colorsDynamic
    if (colorsDynamic == null || this.musicDataHandlerFunc == null) {
      return false
    }

    // 一般情况下需要停止的话，一定是开启过，如果状态是None, 说明是socket断连，状态被重置了。断连状态下不需要再发送socket了
    if (state == MusicCaptureStatus.Stop && this.musicCaptureStatus == MusicCaptureStatus.None) {
      this.musicCaptureStatus = state
      return true
    }
    // 如果音乐律动是停止的，就不需要暂停或者继续，直接返回
    if ((state == MusicCaptureStatus.Pause || state == MusicCaptureStatus.Continue) && colorsDynamic.Run == false) {
      return false
    }

    if (state == MusicCaptureStatus.Pause && this.musicCaptureStatus != MusicCaptureStatus.Start && this.musicCaptureStatus != MusicCaptureStatus.Continue) {
      return false
    }

    if (state == MusicCaptureStatus.Continue && this.musicCaptureStatus != MusicCaptureStatus.Pause) {
      return false
    }

    const ins = await MusicSocket.getIns()

    if (!ins.checkSocket()) {
      if (isElectron()) {
        throw new Error('MusicSocket not connected')
      }
      return false
    }
    const version = await ins.checkSocketVersion()
    if (!version) {
      return false
    }

    this.musicCaptureStatus = state
    if (state == MusicCaptureStatus.Start) {
      deviceManager.subscriberOnDisconnect().then(() => {
        this.dynamicColorState(MusicCaptureStatus.Stop)
      })
      deviceManager.subscriberOnDeviceChange().then(() => {
        this.dynamicColorState(MusicCaptureStatus.Stop)
      })
      ins.setMusicDataHandler(this.musicDataHandlerFunc)
      ins.subscriberMusicSocketClose().then(() => {
        this.onMusicSocketClose()
      })
    }

    const sendData = {
      ID: generateMessageID(),
      Type: DriverSocketMsgType.MTMusicData,
      Data: {
        Mode: colorsDynamic.Mode,
        FullColor: colorsDynamic.FullColor,
        Color: colorsDynamic.Color,
        State: state,
      },
    } as DriverSocketMsg<PostMusicData>
    const aa = await ins.send(sendData)
    console.log(aa, sendData)
    return true
  }

  private onMusicSocketClose() {
    this.musicCaptureStatus = MusicCaptureStatus.None
    fakeSocket.onmessage({
      data: JSON.stringify({
        ID: generateMessageID(),
        Type: DriverSocketMsgType.MSMusicSocketClose,
        Data: null,
        Error: null,
      }),
    } as MessageEvent)
  }
}
